import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, MobileView } from '../types';

export default function setMobileViewReducer(state: AppState, action: PayloadAction<MobileView>) {
  state.mobileView = action.payload;
}
